var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Administrar organización"),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "title is-1" }, [
          _vm._v("Aspectos de documentos"),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "button is-outlined is-primary is-fullwidth",
            attrs: { to: { name: "organizacionCrearAspecto" }, exact: "" },
          },
          [
            _c("i", { staticClass: "fas fa-plus fa-fw" }),
            _vm._v(" Nuevo aspecto\n  "),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Aspectos de la organización disponibles"),
        ]),
        _vm._v(" "),
        _c(
          "b-table",
          {
            attrs: {
              data: _vm.aspectos,
              paginated: "",
              "per-page": "20",
              detailed: "",
              "detail-key": "id",
            },
            scopedSlots: _vm._u([
              {
                key: "detail",
                fn: function (props) {
                  return _vm._l(props.row.atributos, function (attr) {
                    return _c(
                      "article",
                      { key: attr.id, staticClass: "media" },
                      [
                        _c("div", { staticClass: "media-content" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "tag is-dark is-mono is-pulled-right",
                            },
                            [_vm._v(_vm._s(attr.id))]
                          ),
                          _vm._v(" "),
                          _c("b", [_vm._v(_vm._s(attr.nombre))]),
                          _vm._v(" "),
                          attr.obligatorio
                            ? _c("span", { staticClass: "has-text-danger" }, [
                                _vm._v("*"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          attr.descripcion
                            ? _c("p", { staticClass: "is-size-7" }, [
                                !attr.obligatorio
                                  ? _c(
                                      "span",
                                      { staticClass: "has-text-primary" },
                                      [_vm._v("(Opcional)")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {}, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.getNombreAtributo(attr.tipo)) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(attr.descripcion) +
                                    "\n            "
                                ),
                                attr.tipo == "enum"
                                  ? _c("span", [
                                      _c("br"),
                                      _c("b", [_vm._v("Lista de opciones:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            attr.parametros.opciones.join(" • ")
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  })
                },
              },
            ]),
          },
          [
            _c("b-table-column", {
              attrs: { field: "nombre", label: "Nombre", sortable: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("b", [_vm._v(_vm._s(props.row.nombre))]),
                      _vm._v(" "),
                      props.row.descripcion
                        ? _c("p", { staticClass: "is-size-7" }, [
                            _vm._v(_vm._s(props.row.descripcion)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("b-table-column", {
              attrs: { label: "Atributos" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm.atributosList(props.row.atributos).join(", ")
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("b-table-column", {
              attrs: { width: "75" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c(
                        "p",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "is-size-7",
                              attrs: {
                                to: {
                                  name: "organizacionEditarAspecto",
                                  params: {
                                    idOrganization: _vm.idOrganization,
                                    idAspecto: props.row.id,
                                  },
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fas fa-edit" }),
                              _vm._v(" Editar\n      "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "has-text-danger is-size-7",
                            on: {
                              click: function ($event) {
                                return _vm.confirmDelete(props.row.id)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-trash" }),
                            _vm._v(" Eliminar\n      "),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _vm._v(" "),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("p", { staticClass: "is-mono" }, [
                      _vm._v("Sin aspectos"),
                    ]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Otros aspectos disponibles"),
        ]),
        _vm._v(" "),
        _c(
          "b-table",
          {
            attrs: {
              data: _vm.aspectosGlobales,
              paginated: "",
              "per-page": "20",
              detailed: "",
              "detail-key": "id",
            },
            scopedSlots: _vm._u([
              {
                key: "detail",
                fn: function (props) {
                  return _vm._l(props.row.atributos, function (attr) {
                    return _c(
                      "article",
                      { key: attr.id, staticClass: "media" },
                      [
                        _c("div", { staticClass: "media-content" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "tag is-dark is-mono is-pulled-right",
                            },
                            [_vm._v(_vm._s(attr.id))]
                          ),
                          _vm._v(" "),
                          _c("b", [_vm._v(_vm._s(attr.nombre))]),
                          _vm._v(" "),
                          attr.obligatorio
                            ? _c("span", { staticClass: "has-text-danger" }, [
                                _vm._v("*"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          attr.descripcion
                            ? _c("p", { staticClass: "is-size-7" }, [
                                !attr.obligatorio
                                  ? _c(
                                      "span",
                                      { staticClass: "has-text-primary" },
                                      [_vm._v("(Opcional)")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {}, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.getNombreAtributo(attr.tipo)) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(attr.descripcion) +
                                    "\n            "
                                ),
                                attr.tipo == "enum"
                                  ? _c("span", [
                                      _c("br"),
                                      _c("b", [_vm._v("Lista de opciones:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            attr.parametros.opciones.join(" • ")
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  })
                },
              },
            ]),
          },
          [
            _c("b-table-column", {
              attrs: { field: "nombre", label: "Nombre", sortable: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("b", [_vm._v(_vm._s(props.row.nombre))]),
                      _vm._v(" "),
                      props.row.descripcion
                        ? _c("p", { staticClass: "is-size-7" }, [
                            _vm._v(_vm._s(props.row.descripcion)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("b-table-column", {
              attrs: { label: "Atributos" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm.atributosList(props.row.atributos).join(", ")
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _vm._v(" "),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("p", { staticClass: "is-mono" }, [
                      _vm._v("Sin aspectos"),
                    ]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            attrs: { active: _vm.showConfirmDelete },
            on: {
              "update:active": function ($event) {
                _vm.showConfirmDelete = $event
              },
            },
          },
          [
            _c("div", { staticClass: "notification is-light" }, [
              _c("h1", { staticClass: "title is-3" }, [
                _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                _vm._v(" Atención\n      "),
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "subtitle is-6" }, [
                _vm._v(
                  "Está por realizar una acción sin retorno. ¿Confirma que desea eliminar el aspecto?"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-clearfix" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-dark is-outlined",
                    on: {
                      click: function ($event) {
                        _vm.showConfirmDelete = false
                      },
                    },
                  },
                  [_vm._v("Cancelar")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-danger is-pulled-right",
                    on: {
                      click: function ($event) {
                        return _vm.deleteResource()
                      },
                    },
                  },
                  [_vm._v("Eliminar")]
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Los aspectos de documentos son conjuntos de aspectos documentales disponibles para ser usadas en la organización"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }